import { createFileRoute } from "@tanstack/react-router";
import { SpaceWizard } from "./merchant.spaces.new";

export const Route = createFileRoute("/merchant/spaces/$id/edit")({
  head: () => ({
    meta: [
      { title: "Edit space — Spayzo Merchant" },
      { name: "description", content: "Update space details, media, availability, and pricing." },
    ],
  }),
  component: () => <SpaceWizard mode="edit" />,
});
